import { render, staticRenderFns } from "./participacao.vue?vue&type=template&id=3a613ae4"
import script from "./participacao.vue?vue&type=script&lang=js"
export * from "./participacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports